import {combineReducers} from "redux";
import SignInErrorReducer from "./AuthErrorsReducer/SignInErrorsReducer";
import SignUpErrorReducer from "./AuthErrorsReducer/SignUpErrorsReducer";
import ForgetPasswordErrorReducer from "./AuthErrorsReducer/ForgetPasswordErrorsReducer";
import ResetPasswordErrorReducer from "./AuthErrorsReducer/ResetPasswordErrorsReducer";

export default combineReducers({
    signIn: SignInErrorReducer,
    signUp: SignUpErrorReducer,
    forgetPassword: ForgetPasswordErrorReducer,
    resetPassword: ResetPasswordErrorReducer,
});
